import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import { connect } from 'react-redux';
import { isDirty } from 'redux-form';
import formNames from '../../constants/formNames';
import StepComponent from '../_Common/StepComponent';
import { rawMatSelectors } from '../../redux/rawMat';
import { workflowStatusSelectors } from '../../redux/workflowStatus';
import { modalActions } from '../../redux/modal';

const RawMatStatus = props => {
  const { workflowStatusList, statusCode, disabled, onChange, onHistoryClick } = props;
  return (
    <StepComponent
      options={workflowStatusList}
      value={statusCode}
      onChange={onChange}
      disabled={disabled}
      onHistoryClick={onHistoryClick}
    />
  );
};

const mapStateToProps = (state, { rawMatId }) => {
  const rawMat = rawMatSelectors.getById(state)[rawMatId];
  const getWorkflowStatusList = workflowStatusSelectors.makeGetWorkflowStatusListByCode('RAWMAT');
  return {
    disbaled: rawMatSelectors.isNew(state) || isDirty(formNames.rawMat)(state),
    statusCode: R.propOr('', 'Status', rawMat),
    workflowStatusList: getWorkflowStatusList(state),
  };
};

const mapDispatchToProps = (dispatch, { rawMatId }) => ({
  onChange: ({ Code }) => dispatch(modalActions.showRawMatStatusCommentModal({ nextStatusCode: Code, rawMatId })),
  onHistoryClick: () => dispatch(modalActions.showRawMatActionsModal({ rawMatId })),
});

RawMatStatus.propTypes = {
  workflowStatusList: PropTypes.array.isRequired, //eslint-disable-line
  statusCode: PropTypes.string.isRequired,
  disbaled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onHistoryClick: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RawMatStatus);
